import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'
import iView from 'iview';
import ElementUI from 'element-ui'
require('./global/initProject');
require('./global/setting');
import mlUI from 'ml-ui'
import  VueQuillEditor from 'vue-quill-editor'
// require styles 引入样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import 'ml-ui/styles/index.css'
import 'element-ui/lib/theme-chalk/index.css'
import 'iview/dist/styles/iview.css'
import './global/font/iconfont.css'
import './global/rili/stylesheets/simple-calendar.css'

Vue.config.productionTip = false
Vue.use(iView)
Vue.use(ElementUI)
Vue.use(VueQuillEditor)
Vue.use(mlUI)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js